jQuery(document).ready(function($) {
    if (typeof window.CAMPAIGN_DATA ===
        'undefined' ||
        !window.CAMPAIGN_DATA.item ||
        !window.CAMPAIGN_DATA.item[0]) {
        console.warn('Ingen CAMPAIGN_DATA hittades');
        return;
    }

    const feature = window.CAMPAIGN_DATA.item[0];

    const geojson = {
        type: 'FeatureCollection',
        features: [feature],
    };

    const centerCoords = feature.geometry.coordinates;

    mapboxgl.accessToken =
        'pk.eyJ1Ijoic3ZlbnNrYW1vdGVuIiwiYSI6ImNscGw4YnplMjAxZHgya3FqNXlyNTN4bXEifQ.R2jT2ow-QzWrBH6v-pOpDQ';

    const map = new mapboxgl.Map({
        container: document.querySelector('#map'),
        style: 'mapbox://styles/mapbox/streets-v12',
        center: centerCoords,
        zoom: 10,
        cooperativeGestures: !isMobile,
    });

    map.on('load', function() {
        map.addSource('campaign', {
            type: 'geojson',
            data: geojson,
            cluster: true,
            clusterMaxZoom: 14,
            clusterRadius: 50,
        });

        const images = [
            {
                id: 'hotel-marker',
                url: '/wp-content/themes/svenskamoten.se/static/images/map-icon-2x.png',
            },
            {
                id: 'hotel-marker-non-member',
                url: '/wp-content/themes/svenskamoten.se/static/images/map-icon-non-member-2x.png',
            },
        ];

        Promise.all(
            images.map((image) =>
                new Promise((resolve) => {
                    map.loadImage(image.url, (error, result) => {
                        if (!error && result) {
                            map.addImage(image.id, result);
                        }
                        resolve();
                    });
                }),
            ),
        ).then(() => {
            map.addLayer({
                id: 'unclustered-hotels',
                type: 'symbol',
                source: 'campaign',
                layout: {
                    'icon-anchor': 'bottom',
                    'icon-image': [
                        'match',
                        ['get', 'is_promoted'],
                        1, 'hotel-marker',
                        0, 'hotel-marker-non-member',
                        'hotel-marker-non-member',
                    ],
                    'icon-size': 0.25,
                    'icon-allow-overlap': true,
                },
            });
        });
    });
});

//# sourceMappingURL=hotel-campaign-map.js.map
